export default function SectionTitleField({
  label, 
}) {
  return (
    <div className="mb-6 flex items-center justify-center">
      <h1 className="block text-lg font-bold mb-1 text-gray-900">
        {label}
      </h1>
    </div>
  );
}
